import { Icon } from '@design-system/index'
import { colors, elevation, HSLColors, toHSLA } from '@design-system/styles'
import styled from '@emotion/styled'
import { typo } from '@mathflat/common/style'
import { observer } from 'mobx-react-lite'
import { _Badge } from 'src/component/atoms/Badge'
import type { Scenario } from 'src/dto'
import { _mixpanelUtils } from 'src/utils/trackings/_mixpanel'

import modalService from '@/service/modal.service'
import type { ScenarioService } from '@/service/scenario.service'

import ScenarioPopup from './ScenarioPopup'

type Props = {
  scenario: Scenario
  status?: ReturnType<(typeof ScenarioService)['prototype']['getScenarioStatus']>
}

const ScenarioCard = ({ scenario, status = '진행전' }: Props) => {
  return (
    <S.ScenarioCard
      className={status}
      onClick={() => {
        _mixpanelUtils.uiTrack('정복_기능카드_클릭', { 단계: scenario.id, 상태: status })
        if (status === '진행가능' || status === '완료') {
          modalService.openModal(<ScenarioPopup scenario={scenario} />)
          _mixpanelUtils.uiTrack('정복_설명팝업_노출', { 단계: scenario.id })
        }
      }}
    >
      <div className="left">{status === '진행가능' ? <ActiveIcon /> : <InActiveIcon />}</div>
      <div className="right">
        <div className="row">
          <_Badge className="badge" color="#fff">
            {status}
          </_Badge>
        </div>
        <div className="row">
          <strong className="title">{scenario.시나리오카드.title}</strong>
        </div>
        <div className="row" dangerouslySetInnerHTML={{ __html: scenario.시나리오카드.descHTML }} />
      </div>
      <Icon name="chevron_right" size={20} style={{ marginLeft: 2 }} color={colors.gray.$700} />
    </S.ScenarioCard>
  )
}

export default observer(ScenarioCard)

const ActiveIcon = () => {
  return (
    <S.Icon style={{ background: toHSLA({ ...HSLColors.blue.$200, a: 0.2 }) }}>
      <Icon name="check_circle" size={24} color={colors.blue.$300} />
    </S.Icon>
  )
}

const InActiveIcon = () => {
  return (
    <S.Icon
      style={{
        background: toHSLA({ ...HSLColors.gray.$400, a: 0.2 }),
      }}
    >
      <Icon name="check_circle" size={24} color={colors.gray.$700} />
    </S.Icon>
  )
}

const S = {
  ScenarioCard: styled.div`
    display: flex;
    align-items: center;
    padding: 15px 10px;

    width: 260px;
    height: 126px;

    background: #ffffff;

    border: 1px solid ${colors.gray.$500};
    ${elevation.$03};
    border-radius: var(--Radius-200);
    ${typo.caption01};

    .right {
      flex: 0 0 170px;
      height: 100%;
      margin-left: 10px;
    }
    .row + .row {
      margin-top: 4px;
    }

    &.진행가능 {
      border-color: ${colors.blue.$300};
      cursor: pointer;
      .badge {
        background-color: ${colors.blue.$300};
      }
      .title {
        color: ${colors.blue.$400};
      }
      .check-icon {
        fill: ${colors.blue.$300};
      }
    }
    &.진행전 {
      .badge {
        background-color: ${colors.gray.$600};
      }
      .check-icon {
        fill: ${colors.gray.$600};
      }
    }
    &.완료 {
      cursor: pointer;
      .badge {
        background-color: ${colors.gray.$800};
      }
      .check-icon {
        fill: ${colors.gray.$800};
      }
    }
  `,
  Icon: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 38px;
    height: 38px;
    border-radius: var(--Radius-Circle);
  `,
}
